import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({name: 'dcpDate', standalone: false})
export class DcpDateFormatter implements PipeTransform {
  expectedInputFormat: string = moment.HTML5_FMT.DATE;
  outputFormat: string = 'DD MMM YYYY';

  transform(date?: string | null, outputFormat?: string): string {
    const parsedDate: moment.Moment = moment(date, this.expectedInputFormat, true);
    if (!parsedDate || !parsedDate.isValid()) {
      return '';
    }
    const outFormat: string = outputFormat || this.outputFormat;
    return parsedDate.format(outFormat);
  }
}
